import axios from 'axios';

interface CrossRefWork {
    title: string[];
    author?: { given?: string; family?: string }[];
    abstract?: string;
    created: { 'date-time': string };
    URL: string;
}

interface CrossRefResponse {
    message: {
        items: CrossRefWork[];
    };
}

interface Paper {
    title: string;
    summary: string;
    published: string;
    link: string;
    authors: string[];
}

export interface SearchParams {
    keywords?: string;
    yearFrom?: string;
    yearTo?: string;
}

const EMAIL = "thanrajks@datalifex.in";

export const fetchCrossRefFeeds = async (searchParams?: SearchParams): Promise<Paper[]> => {
    try {
        const params: any = {
            mailto: EMAIL,
            rows: 20, // Limit results
        };

        if (searchParams?.keywords) {
            params.query = searchParams.keywords;
        }

        const filters: string[] = [];
        if (searchParams?.yearFrom) {
            filters.push(`from-pub-date:${searchParams.yearFrom}-01-01`);
        }
        if (searchParams?.yearTo) {
            filters.push(`until-pub-date:${searchParams.yearTo}-12-31`);
        }

        if (filters.length > 0) {
            params.filter = filters.join(',');
        }

        const response = await axios.get<CrossRefResponse>('https://api.crossref.org/works', {
            params,
        });

        return response.data.message.items.map((item) => {
            // Abstract often comes as XML-like string, might need cleanup, but for now taking as is or empty
            // Crossref abstracts are not always available or clean.
            let summary = item.abstract || 'No abstract available.';
            // Simple cleanup of tags if present (very basic)
            summary = summary.replace(/<[^>]*>?/gm, '');

            const authors = item.author?.map(a => `${a.given || ''} ${a.family || ''}`.trim()).filter(n => n) || ['Unknown Author'];

            return {
                title: item.title?.[0] || 'Untitled',
                summary: summary,
                published: item.created['date-time'],
                link: item.URL,
                authors: authors
            };
        });
    } catch (error) {
        console.error('Error fetching from CrossRef API:', error);
        throw error;
    }
};
